import { policyComplianceEnumsSubCategoryEnum } from '@/gen/types/PolicyComplianceEnumsSubCategory';
import { policyComplianceEnumsViolationByEmployeeOrByThirdPartyOptionEnum } from '@/gen/types/PolicyComplianceEnumsViolationByEmployeeOrByThirdPartyOption';

import { whenPathEquals } from './conditions';
import { sharedFieldOrder } from './shared-field-order';
import type { IncidentFieldRule } from './types';

export const policyComplianceFieldRules: IncidentFieldRule[] = [
    {
        key: 'attachments',
        label: 'Upload supporting evidence',
        description: 'Attach relevant files such as photos, documents, or screenshots.',
        order: sharedFieldOrder.attachments,
    },
    {
        key: 'subCategory',
        label: 'What kind of policy compliance issue is this?',
        description: 'Select the type of policy compliance issue.',
        order: 90,
    },
    {
        key: 'internalPolicyViolated',
        label: 'Which internal policy was violated?',
        description: 'Enter the name of the internal policy that was violated.',
        kind: 'textarea',
        order: 100,
        visibleWhen: whenPathEquals('subCategory', policyComplianceEnumsSubCategoryEnum.InternalPolicyViolation),
        requiredWhen: whenPathEquals('subCategory', policyComplianceEnumsSubCategoryEnum.InternalPolicyViolation),
    },
    {
        key: 'complianceObligationViolated',
        label: 'Which compliance obligation was violated?',
        description: 'Enter the regulation or obligation that was not met.',
        kind: 'textarea',
        order: 110,
        visibleWhen: whenPathEquals('subCategory', policyComplianceEnumsSubCategoryEnum.ComplianceObligationsViolation),
        requiredWhen: whenPathEquals('subCategory', policyComplianceEnumsSubCategoryEnum.ComplianceObligationsViolation),
    },
    {
        key: 'violationByEmployeeOrByThirdParty',
        label: 'Who is responsible for the violation?',
        description: 'Select whether the violation was by an internal or external party.',
        order: 120,
    },
    {
        key: 'thirdPartyCompany',
        label: 'Third-party company',
        order: 130,
        visibleWhen: whenPathEquals(
            'violationByEmployeeOrByThirdParty',
            policyComplianceEnumsViolationByEmployeeOrByThirdPartyOptionEnum.ThirdPartyActorExternal,
        ),
        requiredWhen: whenPathEquals(
            'violationByEmployeeOrByThirdParty',
            policyComplianceEnumsViolationByEmployeeOrByThirdPartyOptionEnum.ThirdPartyActorExternal,
        ),
    },
];
